import { TriggerConfig, ActionConfig, TriggerDef, ActionDef, CategoryDef } from './types'

export const renderItemSummary = (
  config: TriggerConfig | ActionConfig,
  definitions: (TriggerDef | ActionDef)[],
): string => {
  const defn = definitions.find((d) => d.type === config.type)
  if (!defn) return config.type
  let text = defn.template
  // eslint-disable-next-line security/detect-object-injection
  for (const [key, val] of Object.entries(config.params)) {
    // eslint-disable-next-line security/detect-object-injection
    const schema = defn.params_schema[key]
    if (schema?.type === 'select' && schema.options) {
      const option = schema.options.find((o) => o.value === val)
      text = text.replace(`{${key}}`, option?.label ?? String(val))
    } else {
      text = text.replace(`{${key}}`, String(val ?? ''))
    }
  }
  return text
}

export const findDef = (
  config: TriggerConfig | ActionConfig,
  definitions: (TriggerDef | ActionDef)[],
): TriggerDef | ActionDef | undefined => definitions.find((d) => d.type === config.type)

export const findCategoryIcon = (
  config: TriggerConfig | ActionConfig,
  categories: CategoryDef<TriggerDef | ActionDef>[],
): string => {
  const cat = categories.find((c) => c.key === config.category)
  return cat?.icon ?? 'tune'
}
